import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import Loading from './LoadingComponent'
import 'react-phone-input-2/lib/style.css'
import A12Y_CONST from '../common/a12yConst'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import Select from 'react-select';
import { isValidPhoneNumber } from 'libphonenumber-js';
import ErrorMessageComponent from '../components/ErrorMessageComponent'
import SuccessMessageComponent from '../components/SuccessMessageComponent'
import { useHistory } from "react-router-dom";
import EditChangesRemovePopup from "./EditChangesRemovePopup";

function AddBeneficiaryComponent(props) {
    const [isBtnDisabled, setIsBtnDisabled] = useState(true);
    const [isDataModified, setIsDataModified] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setErrors] = useState(false);
    const [selectedPhoneType1, setSelectedPhoneType1] = useState({});
    const [phoneNumber, setPhoneNumber] = useState('');
    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const [percentOwned, setPercentOwned] = useState('');
    const [phoneNumber_1ErrorMessage, setPhoneNumber_1ErrorMessage] = useState('');
    const [phoneNumberError, setphoneNumberError] = useState(false);
    const [isPopUpVisible, setIsPopUpVisible] = useState(false);
    const [phoneType1LabelActive, setPhoneType1LabelActive] = useState(false);
    const [isEditMode, setEditMode] = useState(false);
    const { register, handleSubmit, setError, control, setFocus, formState: { errors, isSubmitting }, setValue } = useForm({
        mode: "all"
    });
    const history = useHistory();

    const onSubmit = async (user) => {
        // let isPercentValid = validatePercentOwned();
        let IsPhone1DropdownSelected = false;
        let phoneError = false
        let phoneList = [{ type: selectedPhoneType1.label && selectedPhoneType1.label !== 'Select' ? selectedPhoneType1.label.toLowerCase() : '', number: (phoneNumber === '1' || phoneNumber === '') ? '' : phoneNumber }]
        await onBlurEventHandlerPhone();
        if (phoneNumber.length > 1 && phoneNumber !== "1" && Object.keys(selectedPhoneType1).length === 0) {
            phoneError = true
            setphoneNumberError(true)
            IsPhone1DropdownSelected = true
            setPhoneNumber_1ErrorMessage(A12Y_CONST.ERROR_MESSAGE.PLEASE_SELECT_PHONE_TYPE)
            //return;
        } else {
            if (Object.keys(selectedPhoneType1).length > 0 && selectedPhoneType1.label !== 'Select' && (phoneNumber === "" || phoneNumber === "1")) {
                phoneError = true
                setphoneNumberError(true)
                setPhoneNumber_1ErrorMessage(A12Y_CONST.ERROR_MESSAGE.PHONE_NUMBER_IS_INVALID)
                // return
            }
            IsPhone1DropdownSelected = false
        }

        if (phoneNumberError || IsPhone1DropdownSelected || phoneError) {
            return
        }

        let obj = {
            "beneficiary_name": name,
            "email": email,
            // "percentage_ownership" : percentOwned,
            "phones": JSON.stringify(phoneList)
        }
        if (!phoneNumberError) {
            if (props.editMode) {
                props.onUpdate(obj)
            } else {
                props.onSubmit(obj)
            }
        }

    }

    useEffect(() => {
        setLoading(props.loading);
        setErrors(props.error)
    }, [props.loading, props.error])

    useEffect(() => {
        setFocus("name");
    }, [setFocus])

    useEffect(() => {
        const assignDefaultValue = async () => {
            if (props.editMode && Object.keys(props.beneficiaryDetails).length > 0) {
                let beneficiary = props.beneficiaryDetails;
                setName(beneficiary.beneficiary_name)
                setEmail(beneficiary.email)
                setPercentOwned(beneficiary.percentage_ownership)
                if (beneficiary.phones && beneficiary.phones.length > 0) {
                    beneficiary.phones.forEach((phone, index) => {
                        if (phone.type === 'mobile') {
                            setSelectedPhoneType1({ value: 'Mobile', label: 'Mobile' })
                        } else if (phone.type === 'office') {
                            setSelectedPhoneType1({ value: 'Office', label: 'Office' })
                        } else if (phone.type === 'home') {
                            setSelectedPhoneType1({ value: 'Home', label: 'Home' })
                        } else if (phone.type === 'other') {
                            setSelectedPhoneType1({ value: 'Other', label: 'Other' })
                        }
                        if (phone.number.length > 0) {
                            setPhoneNumber(phone.number)
                            setPhoneType1LabelActive(true)
                        } else {
                            setPhoneNumber('')
                        }
                    })
                }
                setEditMode(true)
            }
        }

        assignDefaultValue()
    }, [props.editMode, props.beneficiaryDetails])

    useEffect(() => {
        const checkFormDataIsChanged = async () => {
            let beneficiary = props.beneficiaryDetails;
            setIsDataModified(false)
            setIsBtnDisabled(true)
            props.isDataChanged(false);
            if (isEditMode && Object.keys(props.beneficiaryDetails).length > 0) {
                setIsBtnDisabled(true)
                if (name !== beneficiary.beneficiary_name || percentOwned !== beneficiary.percentage_ownership || (beneficiary.phones[0].number !== '' && phoneNumber === "1") || email !== beneficiary.email || (Object.keys(selectedPhoneType1).length > 0 && beneficiary.phones[0].type !== selectedPhoneType1.value.toLowerCase()) || (phoneNumber !== '' && phoneNumber !== "1" && phoneNumber !== beneficiary.phones[0].number)) {
                    if (name !== "") {
                        setIsBtnDisabled(false)
                    }
                    setIsDataModified(true)
                    props.isDataChanged(true);
                }
            } else {
                if (!props.editMode) {
                    if (name !== '' || percentOwned !== '' || email !== '' || Object.keys(selectedPhoneType1).length > 0 || (phoneNumber !== '' && phoneNumber !== "1")) {
                        if (name !== "") {
                            setIsBtnDisabled(false)
                        }
                        setIsDataModified(true)
                        props.isDataChanged(true);
                    }
                }
            }
        }

        checkFormDataIsChanged()

    }, [isEditMode, phoneNumber, name, email, percentOwned, selectedPhoneType1]) // eslint-disable-line react-hooks/exhaustive-deps

    const phoneTypeList = [
        {
            value: 'select',
            label: 'Select',
            icon: <svg width="14" height="20" viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 2V18H12V2H2ZM1 0H13C13.2652 0 13.5196 0.105357 13.7071 0.292893C13.8946 0.48043 14 0.734784 14 1V19C14 19.2652 13.8946 19.5196 13.7071 19.7071C13.5196 19.8946 13.2652 20 13 20H1C0.734784 20 0.48043 19.8946 0.292893 19.7071C0.105357 19.5196 0 19.2652 0 19V1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0ZM7 15C7.26522 15 7.51957 15.1054 7.70711 15.2929C7.89464 15.4804 8 15.7348 8 16C8 16.2652 7.89464 16.5196 7.70711 16.7071C7.51957 16.8946 7.26522 17 7 17C6.73478 17 6.48043 16.8946 6.29289 16.7071C6.10536 16.5196 6 16.2652 6 16C6 15.7348 6.10536 15.4804 6.29289 15.2929C6.48043 15.1054 6.73478 15 7 15Z" fill="#71767A"></path>
            </svg>,
            iconActive: <svg width="14" height="20" viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 2V18H12V2H2ZM1 0H13C13.2652 0 13.5196 0.105357 13.7071 0.292893C13.8946 0.48043 14 0.734784 14 1V19C14 19.2652 13.8946 19.5196 13.7071 19.7071C13.5196 19.8946 13.2652 20 13 20H1C0.734784 20 0.48043 19.8946 0.292893 19.7071C0.105357 19.5196 0 19.2652 0 19V1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0ZM7 15C7.26522 15 7.51957 15.1054 7.70711 15.2929C7.89464 15.4804 8 15.7348 8 16C8 16.2652 7.89464 16.5196 7.70711 16.7071C7.51957 16.8946 7.26522 17 7 17C6.73478 17 6.48043 16.8946 6.29289 16.7071C6.10536 16.5196 6 16.2652 6 16C6 15.7348 6.10536 15.4804 6.29289 15.2929C6.48043 15.1054 6.73478 15 7 15Z" fill="#0096C7"></path>
            </svg>
        },
        {
            value: 'Mobile',
            label: 'Mobile',
            icon: <svg width="14" height="20" viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 2V18H12V2H2ZM1 0H13C13.2652 0 13.5196 0.105357 13.7071 0.292893C13.8946 0.48043 14 0.734784 14 1V19C14 19.2652 13.8946 19.5196 13.7071 19.7071C13.5196 19.8946 13.2652 20 13 20H1C0.734784 20 0.48043 19.8946 0.292893 19.7071C0.105357 19.5196 0 19.2652 0 19V1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0ZM7 15C7.26522 15 7.51957 15.1054 7.70711 15.2929C7.89464 15.4804 8 15.7348 8 16C8 16.2652 7.89464 16.5196 7.70711 16.7071C7.51957 16.8946 7.26522 17 7 17C6.73478 17 6.48043 16.8946 6.29289 16.7071C6.10536 16.5196 6 16.2652 6 16C6 15.7348 6.10536 15.4804 6.29289 15.2929C6.48043 15.1054 6.73478 15 7 15Z" fill="#71767A"></path>
            </svg>,
            iconActive: <svg width="14" height="20" viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 2V18H12V2H2ZM1 0H13C13.2652 0 13.5196 0.105357 13.7071 0.292893C13.8946 0.48043 14 0.734784 14 1V19C14 19.2652 13.8946 19.5196 13.7071 19.7071C13.5196 19.8946 13.2652 20 13 20H1C0.734784 20 0.48043 19.8946 0.292893 19.7071C0.105357 19.5196 0 19.2652 0 19V1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0ZM7 15C7.26522 15 7.51957 15.1054 7.70711 15.2929C7.89464 15.4804 8 15.7348 8 16C8 16.2652 7.89464 16.5196 7.70711 16.7071C7.51957 16.8946 7.26522 17 7 17C6.73478 17 6.48043 16.8946 6.29289 16.7071C6.10536 16.5196 6 16.2652 6 16C6 15.7348 6.10536 15.4804 6.29289 15.2929C6.48043 15.1054 6.73478 15 7 15Z" fill="#2D6CB2"></path>
            </svg>
        },
        {
            value: 'Office',
            label: 'Office',
            icon: <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 16H22V18H0V16H2V1C2 0.734784 2.10536 0.48043 2.29289 0.292893C2.48043 0.105357 2.73478 0 3 0H13C13.2652 0 13.5196 0.105357 13.7071 0.292893C13.8946 0.48043 14 0.734784 14 1V16H18V8H16V6H19C19.2652 6 19.5196 6.10536 19.7071 6.29289C19.8946 6.48043 20 6.73478 20 7V16ZM4 2V16H12V2H4ZM6 8H10V10H6V8ZM6 4H10V6H6V4Z" fill="#71767A"></path>
            </svg>,
            iconActive: <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 16H22V18H0V16H2V1C2 0.734784 2.10536 0.48043 2.29289 0.292893C2.48043 0.105357 2.73478 0 3 0H13C13.2652 0 13.5196 0.105357 13.7071 0.292893C13.8946 0.48043 14 0.734784 14 1V16H18V8H16V6H19C19.2652 6 19.5196 6.10536 19.7071 6.29289C19.8946 6.48043 20 6.73478 20 7V16ZM4 2V16H12V2H4ZM6 8H10V10H6V8ZM6 4H10V6H6V4Z" fill="#0297C8"></path>
            </svg>
        },
        {
            value: 'Home',
            label: 'Home',
            icon: <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 19.6484H4C3.73478 19.6484 3.48043 19.543 3.29289 19.3555C3.10536 19.1679 3 18.9136 3 18.6484V9.64836H0L10.327 0.260357C10.5111 0.0928353 10.7511 0 11 0C11.2489 0 11.4889 0.0928353 11.673 0.260357L22 9.64836H19V18.6484C19 18.9136 18.8946 19.1679 18.7071 19.3555C18.5196 19.543 18.2652 19.6484 18 19.6484ZM5 17.6484H17V7.80536L11 2.35136L5 7.80536V17.6484ZM11 13.6484C10.337 13.6484 9.70107 13.385 9.23223 12.9161C8.76339 12.4473 8.5 11.8114 8.5 11.1484C8.5 10.4853 8.76339 9.84943 9.23223 9.38059C9.70107 8.91175 10.337 8.64836 11 8.64836C11.663 8.64836 12.2989 8.91175 12.7678 9.38059C13.2366 9.84943 13.5 10.4853 13.5 11.1484C13.5 11.8114 13.2366 12.4473 12.7678 12.9161C12.2989 13.385 11.663 13.6484 11 13.6484Z" fill="#71767A"></path>
            </svg>,
            iconActive: <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 19.6484H4C3.73478 19.6484 3.48043 19.543 3.29289 19.3555C3.10536 19.1679 3 18.9136 3 18.6484V9.64836H0L10.327 0.260357C10.5111 0.0928353 10.7511 0 11 0C11.2489 0 11.4889 0.0928353 11.673 0.260357L22 9.64836H19V18.6484C19 18.9136 18.8946 19.1679 18.7071 19.3555C18.5196 19.543 18.2652 19.6484 18 19.6484ZM5 17.6484H17V7.80536L11 2.35136L5 7.80536V17.6484ZM11 13.6484C10.337 13.6484 9.70107 13.385 9.23223 12.9161C8.76339 12.4473 8.5 11.8114 8.5 11.1484C8.5 10.4853 8.76339 9.84943 9.23223 9.38059C9.70107 8.91175 10.337 8.64836 11 8.64836C11.663 8.64836 12.2989 8.91175 12.7678 9.38059C13.2366 9.84943 13.5 10.4853 13.5 11.1484C13.5 11.8114 13.2366 12.4473 12.7678 12.9161C12.2989 13.385 11.663 13.6484 11 13.6484Z" fill="#0297C8"></path>
            </svg>
        },
        {
            value: 'Other',
            label: 'Other',
            icon: <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.4655 12.3L18.2557 14.9433C18.6601 15.3264 18.6601 15.9704 18.2557 16.3535C16.2347 18.2682 13.1418 18.486 10.8724 16.8735L9.00803 15.5489C7.23388 14.2883 5.64763 12.7823 4.29674 11.0759L3.07878 9.53743C1.33598 7.33599 1.56252 4.16816 3.60084 2.23712C3.94932 1.90698 4.49513 1.90698 4.84361 2.23712L7.67816 4.92248C8.0945 5.31691 8.0945 5.97996 7.67816 6.37439L6.6293 7.36804C6.45432 7.53382 6.41112 7.79583 6.52363 8.009C7.77053 10.3715 9.74929 12.2665 12.1635 13.4101L12.3201 13.4843C12.529 13.5832 12.7772 13.5437 12.945 13.3847L14.09 12.3C14.4757 11.9346 15.0798 11.9346 15.4655 12.3Z" stroke="#71767A" style={{ strokeWidth: 2 }} ></path>
            </svg>,
            iconActive: <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.4655 12.3L18.2557 14.9433C18.6601 15.3264 18.6601 15.9704 18.2557 16.3535C16.2347 18.2682 13.1418 18.486 10.8724 16.8735L9.00803 15.5489C7.23388 14.2883 5.64763 12.7823 4.29674 11.0759L3.07878 9.53743C1.33598 7.33599 1.56252 4.16816 3.60084 2.23712C3.94932 1.90698 4.49513 1.90698 4.84361 2.23712L7.67816 4.92248C8.0945 5.31691 8.0945 5.97996 7.67816 6.37439L6.6293 7.36804C6.45432 7.53382 6.41112 7.79583 6.52363 8.009C7.77053 10.3715 9.74929 12.2665 12.1635 13.4101L12.3201 13.4843C12.529 13.5832 12.7772 13.5437 12.945 13.3847L14.09 12.3C14.4757 11.9346 15.0798 11.9346 15.4655 12.3Z" stroke="#0297C8" style={{ strokeWidth: 2 }}></path>
            </svg>
        }
    ];

    const handleChangePhoneType1 = async e => {
        if (e.label === 'Select') {
            setPhoneNumber("1")
            setphoneNumberError(false)
        } else {
            setphoneNumberError(false)
            setPhoneNumber_1ErrorMessage('')
            onBlurEventHandlerPhone();
        }
        await setSelectedPhoneType1(e);
    }
    const handlePhoneField = e => {
        if (e.length > 1) {
            setPhoneType1LabelActive(true)
        } else {
            setPhoneType1LabelActive(false);
        }
        setPhoneNumber(e)
    }
    const onBlurEventHandlerPhone = () => {
        if (phoneNumber.length > 1) {
            const isValid = validatePhoneNumber(phoneNumber)
            if (!isValid) {
                setphoneNumberError(true)
                setPhoneNumber_1ErrorMessage(A12Y_CONST.ERROR_MESSAGE.PHONE_NUMBER_IS_INVALID)
            } else {
                setphoneNumberError(false)
                setPhoneNumber_1ErrorMessage('')
            }
        }
    }


    const validatePhoneNumber = (e) => {
        const validNumber = '+' + e.toString()
        //    console.log('validNumber',validNumber, typeof validNumber)
        const phoneNumber = isValidPhoneNumber(validNumber)
        //    console.log('phoneNumber')
        return phoneNumber
    }
    const phoneTypeOptions = phoneTypeList && phoneTypeList.map(phoneTypeList => {
        return { label: phoneTypeList.label, value: phoneTypeList.label }
    })

    const handleEmail = (value) => {
        if (value.length === 1 && value === " ") {
            return
        } else {
            setEmail(value);
        }
    }


    useEffect(() => {
        setFocus("name");
    }, [setFocus])

    const handleName = (e) => {
        let value = e.target.value;
        if (value === " ") {
            e.preventDefault();
        } else {
            setName(value);
            setValue('name', value)
        }
    }


    const handeBlankSpace = (e) => {
        if (e.target.value.length < 1) {
            if (e.key === " ") {
                e.preventDefault();
            }
        }
    }
    const onCancel = async () => {
        if (isDataModified) {
            setIsPopUpVisible(true);
        }
        else {
            setIsPopUpVisible(false);
            history.push(A12Y_CONST.ROUTE.INVENTORY_VIEW);
        }
    }

    const handleHidePopup = () => {
        setIsPopUpVisible(false);
    }

    const handleResetAllFields = async () => {
        props.isDataChanged(false)
        setIsPopUpVisible(false);
        history.push(A12Y_CONST.ROUTE.INVENTORY_VIEW);
    }

    return (
        <div className="titleRow margignTop768_13 margignBottom768_10 addActivitiesWrap addBeneficiary">
            {loading ?
                <div className="transparentLayer"></div>
                :
                null
            }
            <h2 className="titleWithSidebar noExpenseTitle marginBottom30">
                <span className="cursorPointer" >
                    <span>{props.dependent?.first_name}'s {A12Y_CONST.LABEL.ADD_ASSET_LABEL}</span></span>
            </h2>
            <div className="dependentBorderBox step4Main paddingBottom70">
                <div className="dependentSubTitle marginBottom10">
                    {A12Y_CONST.TEXT.BENEFICIARY_INFORMATION}
                </div>
                <div className="fullWidth dependentStep3FormCol">
                    {error ?
                        <div className='maxWidth600 marginLeftRightAuto'>
                            <ErrorMessageComponent errorMessage={props.errorMessage} />
                        </div>
                        :
                        (props.message ?
                            <SuccessMessageComponent successMessage={props.message} />
                            :
                            null
                        )
                    }
                    <form onSubmit={handleSubmit(onSubmit)} className='paddingTop30' autoComplete="off">
                        <div className="fullWidth dependentStep3FormCol">
                            <div className='dependentStepFormRow fullWidth dependentRowSpace positionRelative'>
                                <label className='labelCol'>{A12Y_CONST.LABEL.NAME}<span className="astrciBlue">*</span></label>
                                <div className='fullWidth'>
                                    <input
                                        {...register('name', { required: A12Y_CONST.ERROR_MESSAGE.NAME_REQUIRED, })}
                                        placeholder='Name'
                                        className={`fullWidth inputColum24size ${errors.name && 'errorInputBorderRed'}`}
                                        type='text'
                                        onChange={handleName}
                                        value={name}
                                        onKeyDown={e => handeBlankSpace(e)}
                                        maxLength="256"
                                        id='displayName'
                                        onFocus={() => {
                                            setError("name", {
                                                type: "manual",
                                                message: "",
                                            });
                                        }}
                                    />
                                    <div className='errorRelativeRow'> {errors.name && <p className='errorMessage'>{errors.name.message}</p>}</div>
                                </div>
                            </div>
                            <div className='dependentStepFormRow fullWidth dependentRowSpace positionRelative'>
                                <label className='labelCol emailStep4'>{A12Y_CONST.LABEL.DEPENDENT_EMAIL}</label>
                                <div className='fullWidth'>
                                    <input
                                        {...register('email', {
                                            pattern: {
                                                //value:/^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9]{1,61}$/,
                                                //eslint-disable-next-line
                                                value: /^\w+([\+.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
                                                message: A12Y_CONST.ERROR_MESSAGE.SIGNUP_USERNAME_INVALID
                                            }
                                        })}
                                        placeholder='name@example.com'
                                        className={errors.email ? 'inputColum24size errorInputBorderRed' : 'inputColum24size'}
                                        type='text'
                                        id='displayName'
                                        autoComplete="none"
                                        onChange={(e) => handleEmail(e.target.value)}
                                        value={email}
                                        onFocus={() => {
                                            setError("email", {
                                                type: "manual",
                                                message: "",
                                            });
                                        }}
                                    />
                                    <div className='errorRelativeRow'> {errors.email && <p className='errorMessage'>{errors.email.message}</p>}</div>
                                </div>
                            </div>
                            <div className='dependentStepFormRow fullWidth dependentRowSpace positionRelative'>
                                <label className='labelCol phoneStep4'>{A12Y_CONST.LABEL.DEPENDENT_PHONE}</label>
                                <div className='fullWidth'>
                                    <div className='width50 paddingRight16 selectBoxParend myProfilePhoneCol1_600'>
                                        <div className={(selectedPhoneType1 && Object.keys(selectedPhoneType1).length > 0 ? 'hasValue ' : 'noValue ') + 'fullWidth phoneTypeCol positionAbsoutePhoneLabel positionTop maxWidth138px phoneDropDownResponsiveCol'}>
                                            <Controller
                                                name="phoneNumber1"
                                                render={({ field }) => (
                                                    <Select
                                                        {...field}
                                                        value={selectedPhoneType1.label ? selectedPhoneType1 : ""}
                                                        placeholder="Select"
                                                        options={phoneTypeOptions}
                                                        onChange={handleChangePhoneType1}
                                                        classNamePrefix={phoneType1LabelActive ? 'phoneNumberActive phoneType1' : 'phoneType1'}
                                                    />
                                                )}
                                                //onChange={handleActivityTypeChange}
                                                control={control}
                                                className="fullwidth inputColum24size"
                                                placeholder="Select"
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 0,
                                                    colors: {
                                                        ...theme.colors,
                                                        text: 'red',
                                                        primary: '#0096C708',
                                                    },
                                                })}
                                            />
                                        </div>
                                        <div>
                                            <PhoneInput
                                                country='us'
                                                disabled={Object.keys(selectedPhoneType1).length > 0 && selectedPhoneType1.label === 'Select' ? true : false}
                                                countryCodeEditable={false}
                                                containerClass={phoneType1LabelActive ? phoneNumberError ? 'errorInputBorderRedInput phoneNumber_Active' : phoneNumber === "1" ? 'phone_number_placeholder_color null' : 'phoneNumber_Active' : phoneNumberError ? 'errorInputBorderRedInput' : null}
                                                value={phoneNumber}
                                                onBlur={onBlurEventHandlerPhone}
                                                inputProps={{
                                                    name: 'phone',
                                                    required: true,
                                                }}
                                                onChange={phone => { handlePhoneField(phone) }}
                                                onFocus={() => { setphoneNumberError(false) }}

                                            />
                                        </div>
                                        <div className='errorRelativeRow'> {phoneNumberError ? <p className='errorMessage'>{phoneNumber_1ErrorMessage}</p> : null}</div>
                                    </div>
                                </div>
                            </div>

                            <div className="fullWidth textAlignRight dependentButtonRowBottom displayFlexCol" >
                                <div className='widthAuto'><input id={A12Y_CONST.BUTTON_ID.ADD_BENEFICIARY_CANCEL} className={!isSubmitting ? "cancelButton1 buttonlaerUp" : 'cancelButton1 buttonlaerUp'} onClick={onCancel} type="button" value={A12Y_CONST.BUTTON_TEXT.CANCEL} /></div>
                                <div className='widthAuto marginButton buttonRightMargin'>
                                    <div className='loaderSpinner'>
                                        {loading ?
                                            <Loading />
                                            :
                                            null
                                        }
                                        <input id={A12Y_CONST.BUTTON_ID.ADD_BENEFICIARY_SAVE} className={loading || isBtnDisabled ? "saveButtonDisable buttonlaerUp" : 'saveButton buttonlaerUp'} disabled={loading || isBtnDisabled} type="submit" value={A12Y_CONST.BUTTON_TEXT.SAVE} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <EditChangesRemovePopup
                popUpStatus={isPopUpVisible}
                hidePopUp={handleHidePopup}
                resetAllFields={handleResetAllFields}
            />
        </div>
    )
}

export default AddBeneficiaryComponent;